import { ProductsActions } from "../../reducers/products/ActionsNames";

export default function (id: number, many?: boolean) {
  return {
    type: ProductsActions.SelectProduct,
    id,
    many
  };
}
